const dummyJobs = [];

export function getJobStats(jobs = []) {
  const total = jobs.length;
  const pending = jobs.filter(j => j.status === 'Pending').length;
  const inProgress = jobs.filter(j => j.status === 'In Progress').length;
  const assigned = jobs.filter(j => j.status === 'Assigned').length;
  const ready = jobs.filter(j => j.status === 'Ready').length;
  const income = jobs.reduce((s, j) => s + (j.amount || 0), 0);
  return { total, pending, inProgress, assigned, ready, income };
}

export function getTechnicians(jobs = []) {
  return Array.from(new Set(jobs.map(j => j.technician).filter(Boolean)));
}

export default dummyJobs;
